import React from 'react';
import { createPortal } from 'react-dom';
import * as S from './TmpPanel.styled';
import { moveTmpPanel } from 'pages/Navigation/utils';

const TmpPanel = ({ component, id }:{ component: React.JSX.Element, id: string }) => {
  // Portal to body so the dark overlay + panel sit above the mobile app header
  // (LFHeader lives outside the page stacking context that normally wraps TmpPanel).
  return createPortal(
    <>
      <S.Bg
        id={`${id}_bg`}
        onClick={() => {
          moveTmpPanel(id);
        }}
      />
      <S.Container id={id}>
        {component}
      </S.Container>
    </>,
    document.body,
  );
};

export default TmpPanel;
